import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { inlineIcon } from 'assets/images';

import styles from './style.module.scss';

function CodeCard({ script, textColor, title }) {
  const { t } = useTranslation('global');
  const [showCopied, setShowCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(script);
    setShowCopied(true);
    setTimeout(() => {
      setShowCopied(false);
    }, 1000);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.topHeader}>
          <h3>{title}</h3>
          <img
            aria-hidden
            className={clsx(styles.icon, styles.copyable)}
            src={inlineIcon}
            alt="inline icon"
            onClick={copyToClipboard}
            loading="lazy"
          />
          {showCopied && <div className={styles.copiedText}>{t('copied')}</div>}
        </div>
      </div>

      <div className={styles.codeContainer}>
        <pre className={styles.codeStyle} style={{ color: textColor }}>
          {script}
        </pre>
      </div>
    </div>
  );
}

export default CodeCard;
